import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import cx from 'classnames'
import _ from 'lodash'

import CloseButton from '../../../../../../../../../../components/CloseButton'
import { sendMessage } from '../../../../../../../../../../services/socket/helpers'

import { LOCALE_PREFIX, ANIMATED_PROGRESS_BARS, TASK_STATES, TYPES, WS_EXPORTS_REMOVE_TASK } from '../../constants'

import ProgressBar from './components/ProgressBar'

import hocConnect from './hocConnect'
import './style.scss'

@injectIntl
@hocConnect
export default class ExportsRow extends Component {
    static propTypes = {
        data: PropTypes.object,
        exportsGetTaskFile: PropTypes.func.isRequired,
        exportsTaskRemove: PropTypes.func.isRequired,
        intl: PropTypes.object,
        state: PropTypes.string,
        type: PropTypes.string,
    }

    handleCloseBtnClick = () => {
        const {
            data: { module, entId, id },
            exportsTaskRemove,
        } = this.props

        if (!id || !entId || !module) return null

        sendMessage(WS_EXPORTS_REMOVE_TASK, { jobId: id })
        exportsTaskRemove(module, entId, id)
        return null
    }

    handleTextsClick = () => {
        const {
            data: {
                module,
                entId,
                id,
                state,
                meta: { type },
                settings,
            },
            exportsGetTaskFile,
            exportsTaskRemove,
            createPdfExportTask,
            createXlsExportTask,
        } = this.props

        // Download file
        if (state === TASK_STATES.SUCCEEDED) {
            exportsGetTaskFile(module, entId, id)
            return null
        }

        // Retry task (remove failed task, create new)
        if (state === TASK_STATES.FAILED) {
            exportsTaskRemove(module, entId, id)

            if (type === TYPES.PDF) {
                createPdfExportTask(module, entId, settings)
                return null
            }

            if (type === TYPES.XLS) {
                createXlsExportTask(module, entId, settings)
                return null
            }
        }

        return null
    }

    render() {
        const { data, intl } = this.props

        return (
            <div className={cx('export-row-wrap', _.toLower(data?.state))}>
                <div className={'export-desc-wrapper'}>
                    <div className={cx('icon', `icon-${_.toLower(data?.meta?.type)}`)} />
                    <div className={'texts'} onClick={this.handleTextsClick}>
                        <div className={'export-file-name'} title={data?.meta?.fileName || ''}>
                            {data?.meta?.fileName || ''}
                        </div>
                        <div className={'export-state'}>
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.state.${_.toLower(data?.state)}`}
                                defaultMessage={'Error'}
                            />
                        </div>
                    </div>
                </div>
                <div className={'progress-bar-wrapper'}>
                    <ProgressBar
                        width={100}
                        variant={_.toLower(data?.state)}
                        animated={ANIMATED_PROGRESS_BARS.includes(data?.state)}
                    />
                </div>
                <div className={'close-area'}>
                    <CloseButton
                        title={intl.formatMessage({ id: `${LOCALE_PREFIX}.deleteRowBtnTitle` })}
                        onClick={this.handleCloseBtnClick}
                        pad={2}
                        size={12}
                    />
                </div>
            </div>
        )
    }
}
